import deleteDialog from './deleteDialog';
import submitDialog from './submitDialog';
import tagEdit from './tagEdit';

export default {
  install (Vue) {
    Vue.prototype.$common = {
      deleteDialog,
      submitDialog,
      tagEdit
    }
  }
}